import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { useIntl } from "react-intl";
import {
    EuiModal,
    EuiModalBody,
    EuiModalFooter,
    EuiModalHeader,
    EuiModalHeaderTitle,
} from "@elastic/eui";
import Button from "./button";

const ModalGlobalStyle = createGlobalStyle`

    .euiOverlayMask {
        padding-bottom: 0 !important;
    }

    .euiModal__flex {
        max-height: 100vh !important;
    } 
    
`;

const StyledEuiModal = styled(EuiModal)`
    & .euiModal__closeIcon {
        top: 24px;
        right: ${(props) => props.children[1].props.children.props.dir === "ltr" && "24px"};
        left: ${(props) => props.children[1].props.children.props.dir === "rtl" && "24px"};

        svg {
            width: 24px;
            height: 24px;
        }
    }

    &.euiModal--maxWidth-default {
        max-width: ${(props) => (props.size === "large" ? "80vw" : "40vw")};
        width: ${(props) => (props.size === "large" ? "80vw" : "40vw")};
    }

    & .euiModalHeader {
        padding: 24px 0px;
    }
`;

export const StyledHeader = styled.header`
    width: 100%;
    font-size: 1.6rem;
    font-weight: 700;
    margin-left: ${(props) => (props.dir === "ltr" ? "24px" : "-24px")};
    color: #111827;
    display: flex;
    justify-content: space-between;
    border-bottom: ${({ borderedHeader }) => (borderedHeader ? "1px solid #E2E3E4" : "none")};
    padding-bottom: ${({ borderedHeader }) => (borderedHeader ? "10px" : "0")};
`;

const StyledEuiModalHeaderTitle = styled(EuiModalHeaderTitle)`
    width: 100%;

    h1 {
        margin-left: 24px;
    }
`;

export const StyledFooter = styled.footer`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
    align-items: center;
`;

export const StyledBody = styled.div`
    width: 100%;
    font-weight: 400;
    margin: 0.8rem 0;
    color: #6b7280;
`;

const StyledEuiModalBody = styled(EuiModalBody)`
    &.modal-body {
        overflow-y: scroll;

        & .euiModalBody__overflow {
            overflow-y: visible !important;
            overflow-x: visible !important;
            mask-image: none !important;
            -webkit-mask-image: none !important;
        }
    }
`;

export default function ModalComponent({
    children,
    header,
    open,
    onClose,
    onSubmit,
    submitBtn,
    submitBtnText,
    cancelBtn,
    isFooter,
    size,
    disabled,
    borderedHeader,
}) {
    const { locale } = useIntl();
    return (
        open && (
            <>
                <ModalGlobalStyle />
                <StyledEuiModal
                    onClose={onClose}
                    size={size}
                >
                    <EuiModalHeader>
                        <StyledEuiModalHeaderTitle>
                            <StyledHeader
                                toggler={onClose}
                                borderedHeader={borderedHeader}
                                dir={locale === "ar" ? "rtl" : "ltr"}
                            >
                                {header}
                            </StyledHeader>
                        </StyledEuiModalHeaderTitle>
                    </EuiModalHeader>

                    <StyledEuiModalBody className="modal-body">
                        <StyledBody dir={locale === "ar" ? "rtl" : "ltr"}>{children}</StyledBody>
                    </StyledEuiModalBody>
                    {isFooter && (
                        <EuiModalFooter>
                            <StyledFooter dir={locale === "ar" ? "rtl" : "ltr"}>
                                {cancelBtn && (
                                    <Button
                                        onChange={onClose}
                                        name={locale === "ar" ? "الغاء" : "cancel"}
                                        btnStyle="secondBtn"
                                    />
                                )}
                                {submitBtn && (
                                    <Button
                                        onChange={onSubmit}
                                        name={submitBtnText}
                                        btnStyle={`primaryBtn ${disabled ? "disabled" : ""}`}
                                        disabled={disabled}
                                    />
                                )}
                            </StyledFooter>
                        </EuiModalFooter>
                    )}
                </StyledEuiModal>
            </>
        )
    );
}
